export const GET_CATEGORIES_REQUEST = "GET_CATEGORIES_REQUEST";